import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import usePosition from 'Components/Posistion';
import Box from '@material-ui/core/Box';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Button, Grid, Paper, CircularProgress } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { USERValidateOTP as USER_VALIDATE_OTP } from 'Components/Api/OneClickAEPSAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';

const CustomContainer = HOCLoader(Container);

export const OneClickValidateOTP = () => {
    const history = useHistory();
    const classes = commonStyle();
    const location = useLocation();
    const { latitude, longitude } = usePosition();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const EncodeFPTxnId = location?.state?.EncodeFPTxnId;
    const PrimaryKeyId = location?.state?.PrimaryKeyId;
    const AadhaarNo = location?.state?.AadhaarNo ?? "";
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);

    const [formObject, setFormObject] = useState({
        EncodeFPTxnId: EncodeFPTxnId,
        PrimaryKeyId: PrimaryKeyId,
        OTP: '',
        AadhaarNo: AadhaarNo,
        Latitude: latitude,
        Longitude: longitude
    });

    useEffect(() => {
        setFormObject({
            EncodeFPTxnId: EncodeFPTxnId,
            PrimaryKeyId: PrimaryKeyId,
            AadhaarNo: AadhaarNo,
            Latitude: latitude,
            Longitude: longitude,
            OTP: '',
        });
    }, []);

    const submitHandleData = async (values) => {
        setResponseMessage('');
        setIsError(false);
        setLoading(false);
        const requestValues = {
            Otp: values.OTP,
            PrimaryKeyId: PrimaryKeyId,
            EncodeFPTxnId: EncodeFPTxnId,
            AadharNo: AadhaarNo,
            Latitude: latitude,
            Longitude: longitude
        };
        var requestObj = JSON.stringify(requestValues);
        var response = await USER_VALIDATE_OTP(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        setSeverity('success');
        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);
            setStatus('FAILURE');
            setMessage(dataError.Message);
            setIsAlertErrorOpen(true);
            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);

            if (data.Message === 'User not onboarded') {
                history.push('/OCUserOnbording', {
                    latitude: latitude,
                    longitude: longitude
                });
                return;
            }
            return;
        }

        setResponseMessage(data.Message);
        let param = {
            AadhaarNo: AadhaarNo,
            MobileNo: requestValues.MobileNo,
            PrimaryKeyId: PrimaryKeyId,
            EncodeFPTxnId: EncodeFPTxnId,
            Latitude: latitude,
            Longitude: longitude,
        };
        history.push('/OCBiomatric', param);
    };

    const FormValidationSchema = Yup.object({
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'OTP')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandleData}
                resetForm={formObject}
                render={({ values, error, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        User Validation OTP
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="AadharNo"
                                                        name="AadharNo"
                                                        type="text"
                                                        value={AadhaarNo}
                                                        placeholder="Aadhar Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="OTP"
                                                        name="OTP"
                                                        type="text"
                                                        length={8}
                                                        placeholder="OTP"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Validate OTP"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Validate OTP
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
            {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            )}
        </CustomContainer>
    );
};
